import {
  Email,
  Facebook,
  Instagram,
  Phone,
  YouTube,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 4,
        mt: 5,
        backgroundColor: "#EE82EE",
        backgroundImage: "linear-gradient(90deg, #FF9800 0%, #FF5722 100%)",
        borderRadius: "8px",
        borderTop: "2px solid #ddd",
      }}
    >
      <Grid container spacing={3} justifyContent="center">
        {/* Quick Links */}
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Typography variant="h6" fontWeight="bold" color="primary">
            Quick Links
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              Home
            </Link>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link
              to="/recipes"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Recipes
            </Link>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link
              to="/blog"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Blogs
            </Link>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link
              to="/products"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Our Products
            </Link>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link
              to="/aboutUs"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              About Us
            </Link>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textDecoration: "none",
              "&:hover": { color: "secondary.main" },
            }}
          >
            <Link
              to="/contact"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              Contact Us
            </Link>
          </Typography>
        </Grid>

        {/* Social Media */}
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Typography variant="h6" fontWeight="bold" color="primary">
            Follow Us
          </Typography>
          <IconButton
            href="https://www.youtube.com/@SonikaTheChef"
            target="_blank"
            color="error"
            sx={{
              m: 1,
              textDecoration: "none",
              transform: "scale(1.05)",
              boxShadow: 15,
              "&:hover": { color: "green" },
            }}
          >
            <YouTube />
          </IconButton>
          <IconButton
            href="https://www.instagram.com"
            target="_blank"
            color="secondary"
            sx={{
              m: 1,
              textDecoration: "none",
              transform: "scale(1.05)",
              boxShadow: 15,
              "&:hover": { color: "green" },
            }}
          >
            <Instagram />
          </IconButton>
          <IconButton
            href="https://www.facebook.com/sonika.garg.940098"
            target="_blank"
            color="primary"
            sx={{
              m: 1,
              textDecoration: "none",
              transform: "scale(1.05)",
              boxShadow: 15,
              "&:hover": { color: "green" },
            }}
          >
            <Facebook />
          </IconButton>
        </Grid>

        {/* Contact Information */}
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Typography variant="h6" fontWeight="bold" color="primary">
            Contact Us
          </Typography>
          <Typography variant="body2">
            <Email sx={{ verticalAlign: "middle", mr: 1 }} />
            sonikathechef@gmail.com
          </Typography>
          <Typography variant="body2">
            <Phone sx={{ verticalAlign: "middle", mr: 1 }} />
            +91 xxxxx xxxxx
          </Typography>
        </Grid>

        {/* Newsletter Subscription */}
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Typography variant="h6" fontWeight="bold" color="primary">
            Subscribe for Updates
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}
          >
            <TextField
              variant="outlined"
              size="small"
              placeholder="Enter your email"
              sx={{ backgroundColor: "white", borderRadius: 1 }}
            />
            <Button variant="contained" color="secondary">
              Subscribe
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body2" color="white">
            © 2024 Sonika The Chef. All Rights Reserved.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
